module.exports = "/_next/static/files/a9c97c684e180eabb41e9377546a7b98.png";